import Head from 'next/head';

import { PageWrapper, TextIntro, ContactForm } from '@components';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React from 'react';

const ContactUsPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>Contact Us | Valearnis</title>
        <meta
          name="description"
          content="Get in touch with ManezCo, the team behind Valearnis. Enquire about our app, curriculum, pricing plans for parents & schools, and more!"
        />
      </Head>
      <PageWrapper alignItems={'center'}>
        <TextIntro
          heading={'Say Hello!'}
          body={
            'Do you have any questions or suggestions? Or maybe you just want to share interesting information? Sending us a message will allow us to keep you updated via email.'
          }
        />
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.NEXT_PUBLIC_GR_PUB_KEY}
        >
          <ContactForm />
        </GoogleReCaptchaProvider>
      </PageWrapper>
    </>
  );
};

export default ContactUsPage;
